import type { IListResponse, IPersonCharacters, ISubjectRelations } from '@dakedake/types'
import { request } from '@umijs/max'

/** 获取关联详情 GET /backend/subjectRelations/:id */
export async function subjectRelationsDetail(options?: Record<string, any>) {
  return request<{ data: ISubjectRelations }>('/backend/subjectRelations/:id', {
    method: 'GET',
    ...options
  })
}

/** 获取关联产品列表 GET /backend/subjectRelations/list */
export async function subjectRelationsList(params: {
  sid?: number
  aid?: number /** 当前的页码 */
  current?: number
  /** 页面的容量 */
  pageSize?: number
}) {
  return request<IListResponse<ISubjectRelations>>('/backend/subjectRelations/list', {
    method: 'GET',
    params
  })
}
/** 添加/编辑关联产品 POST /api/subjectRelations/add */
export async function subjectRelationsAdd(body: ISubjectRelations) {
  return request<{ data: ISubjectRelations, status: number, message: string }>('/backend/subjectRelations/add', {
    method: 'POST',
    data: body
  })
}

/** 添加/人物关联角色 POST /api/personCharacters/add */
export async function personCharactersAdd(body: IPersonCharacters) {
  return request<{ data: IPersonCharacters, status: number, message: string }>('/backend/personCharacters/add', {
    method: 'POST',
    data: body
  })
}

/** 删除关联产品 DELETE /api/subjectRelations/delete */
export async function subjectRelationsDelete(body: { id?: number, sid?: number, rid?: number }) {
  return request<{ data: number }>('/backend/subjectRelations/delete', {
    method: 'DELETE',
    data: body
  })
}

/** 删除人物关联角色 DELETE /api/personCharacters/delete */
export async function personCharactersDelete(body: { id?: number }) {
  return request<{ data: number }>('/backend/personCharacters/delete', {
    method: 'DELETE',
    data: body
  })
}
